import React from 'react'
import { faAdd, faCircleInfo, faTrash } from '@fortawesome/free-solid-svg-icons'
import { OrdersContext } from 'contexts/OrdersContext'
import { isEmpty } from 'lodash'
import {
  $DCprimaryColor,
  DcButton,
  Link,
  PixelCurrency,
  PixelFlexBox,
  PixelHeaderPanel,
  PixelIcon,
  PixelText,
  PixelFactoryContext,
} from 'pixel-base'
import styled from 'styled-components'

import {
  deleteInvoiceShippingLine,
  deleteShippingLine,
} from 'utils/api-routes.util'

import AddEditShippingLine from './subComponents/AddEditShippingLine'
import { IPixelFactory, OrderDetail } from '../../../../../decl.d'

interface IProps {
  details: OrderDetail
  detailID: number
  setDetails: (details: OrderDetail) => void
  newOrder: boolean
  newOrderData: OrderDetail
  setNewOrderData: (newOrderData: OrderDetail) => void
  isItInvoice: boolean
}
const OrderShipping = (props: IProps) => {
  const { showPageLoader, hidePageLoader, showSuccess, pixelConfirm } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const {
    details,
    detailID,
    setDetails,
    newOrder,
    newOrderData,
    setNewOrderData,
    isItInvoice,
  } = props
  const { state } = React.useContext(OrdersContext)
  const [shippingMethod, setShippingMethod] = React.useState([])
  const [addAble, setAddAble] = React.useState(false)

  React.useEffect(() => {
    if (shippingMethod.length === 0) setShippingMethod(state?.shippingMethods)
  }, [state.shippingMethods])

  const AddEditShipping = (
    <ADDShippingLines>
      <AddEditShippingLine
        isItInvoice={isItInvoice}
        shippingMethod={shippingMethod}
        detailID={detailID}
        newOrder={newOrder}
        newOrderData={newOrderData}
        setNewOrderData={setNewOrderData}
        handleClose={(data) => {
          setAddAble(false)
          if (data) {
            setDetails(data)
          }
        }}
      />
    </ADDShippingLines>
  )

  const ShippingHeader = (
    <HeaderEnd>
      {details?.invoice_id && details?.invoice_status === 'open' ? (
        details?.order_shipping?.length !== 0 ? (
          <>
            <Link>
              <PixelIcon
                showTooltip
                tooltip="Delete existing to add new"
                fontSize="1x"
                color={$DCprimaryColor}
                icon={faCircleInfo}
              />
            </Link>
            <NotAllowed>
              {' '}
              <PixelIcon
                icon={faAdd}
                color={$DCprimaryColor}
                showTooltip
                tooltip="Add"
              />
            </NotAllowed>
          </>
        ) : (
          <DcButton size="sm" variant="link" onClick={() => setAddAble(true)}>
            <PixelIcon
              icon={faAdd}
              color={$DCprimaryColor}
              showTooltip
              tooltip="Add"
            />
          </DcButton>
        )
      ) : details?.order_shipping?.length !== 0 ? (
        <>
          <Link>
            <PixelIcon
              showTooltip
              color={$DCprimaryColor}
              tooltip="Delete existing to add new"
              fontSize="1x"
              icon={faCircleInfo}
            />
          </Link>
          <NotAllowed>
            {' '}
            <PixelIcon
              icon={faAdd}
              color={$DCprimaryColor}
              showTooltip
              tooltip="Add"
            />
          </NotAllowed>
        </>
      ) : (
        <DcButton size="sm" variant="link" onClick={() => setAddAble(true)}>
          {' '}
          <PixelIcon
            icon={faAdd}
            color={$DCprimaryColor}
            showTooltip
            tooltip="Add"
          />
        </DcButton>
      )}
    </HeaderEnd>
  )

  const handleDeleteShippingLine = (index) => {
    if (newOrder === true) {
      setNewOrderData({
        ...newOrderData,
        shipping_lines: newOrderData.shipping_lines.filter(
          (item, i) => i !== index,
        ),
      })
    } else {
      pixelConfirm({
        title: 'Delete Shipping Line',
        message:
          'Are you sure? you want to delete this Shipping, This action cannot be undone.',
        onConfirm: () => {
          if (isItInvoice) {
            details?.order_shipping?.map((item, i) => {
              deleteInvoiceShippingLine(item.order_id, item.item_id).subscribe(
                (res: any) => {
                  hidePageLoader()
                  if (res.response.data) {
                    showSuccess('Successfully Deleted')
                    setDetails(res.response.data)
                  }
                  if (i === details?.order_shipping?.length - 1) {
                    hidePageLoader()
                  }
                },
              )
            })
          } else {
            showPageLoader()
            details?.order_shipping?.map((item, i) => {
              deleteShippingLine(detailID, item.item_id).subscribe(
                (res: any) => {
                  hidePageLoader()
                  if (res.response.data) {
                    showSuccess('Successfully Deleted')
                    setDetails(res.response.data)
                  }
                  if (i === details?.order_shipping?.length - 1) {
                    hidePageLoader()
                  }
                },
              )
            })
          }
        },
      })
    }
  }

  return (
    <PixelFlexBox flexDirection="column">
      <PixelFlexBox
        flexDirection="column"
        alignContent="center"
        style={{
          borderBottom: '1px solid #e6e6e6',
        }}
      >
        <PixelHeaderPanel padding="10px 0px" alignItem="center">
          <PixelText
            textSize="16px"
            color="rgba(0, 0, 0, 0.84)"
            style={{ fontWeight: '600', padding: '10px' }}
          >
            Shipping Line
          </PixelText>
          {newOrder ? (
            // --------------------- new order --------------------------------
            <>
              {!addAble ? (
                <ADDShippingLines>
                  <AddEditShippingLine
                    shippingMethod={shippingMethod}
                    detailID={detailID}
                    newOrder={newOrder}
                    newOrderData={newOrderData}
                    setNewOrderData={setNewOrderData}
                    handleClose={(data) => {
                      setAddAble(true)
                      if (data?.invoice_balance_amount && details) {
                        setDetails({
                          ...details,
                          invoice_balance_amount: data.invoice_balance_amount,
                        })
                      } else if (data?.invoice_balance_amount && newOrderData) {
                        setNewOrderData({
                          ...newOrderData,
                          invoice_balance_amount: data.invoice_balance_amount,
                        })
                      }
                    }}
                  />
                </ADDShippingLines>
              ) : (
                <HeaderEnd>
                  <>
                    <DcButton
                      size="sm"
                      variant="link"
                      onClick={() => {
                        setAddAble(false)
                      }}
                    >
                      <PixelIcon
                        tooltip="Add"
                        showTooltip
                        icon={faAdd}
                        color={$DCprimaryColor}
                      />
                    </DcButton>
                  </>
                </HeaderEnd>
              )}
            </>
          ) : (
            <>
              {details?.invoice_id && details?.invoice_status === 'open' ? (
                addAble ? (
                  AddEditShipping
                ) : (
                  ShippingHeader
                )
              ) : (
                <>
                  {details?.is_editable === true &&
                    (addAble ? AddEditShipping : ShippingHeader)}
                </>
              )}
            </>
          )}
        </PixelHeaderPanel>
      </PixelFlexBox>

      {newOrder ? (
        // --------------------- new order --------------------------------
        <>
          {newOrderData?.shipping_lines?.length > 0 && (
            <InnerSection>
              {newOrderData?.shipping_lines?.map((item, index) => {
                return (
                  <PaymentContainer key={index}>
                    <DiscountTitle>{item.method_title}</DiscountTitle>
                    <Amounts>
                      <PixelCurrency value={item.total} />
                    </Amounts>

                    <Actions>
                      <PixelIcon
                        showTooltip
                        tooltip="Delete"
                        icon={faTrash}
                        color="red"
                        fontSize="1x"
                        onClick={() => {
                          handleDeleteShippingLine(index)
                        }}
                      />
                    </Actions>
                  </PaymentContainer>
                )
              })}
            </InnerSection>
          )}
        </>
      ) : (
        <>
          {details?.order_shipping?.length > 0 && (
            <InnerSection>
              <PaymentContainer>
                <DiscountTitle>
                  {details?.order_shipping[0]?.method_title}
                </DiscountTitle>
                <Amounts>
                  <PixelCurrency value={details?.order_shipping[0]?.total} />
                </Amounts>
                {details?.invoice_id ? (
                  <>
                    {details?.invoice_status === 'open' && (
                      <Actions>
                        <PixelIcon
                          showTooltip
                          tooltip="Delete"
                          icon={faTrash}
                          color="red"
                          fontSize="1x"
                          onClick={() => {
                            handleDeleteShippingLine(0)
                          }}
                        />
                      </Actions>
                    )}
                  </>
                ) : (
                  <>
                    <Actions>
                      <PixelIcon
                        showTooltip
                        tooltip="Delete"
                        icon={faTrash}
                        color="red"
                        fontSize="1x"
                        onClick={() => {
                          handleDeleteShippingLine(0)
                        }}
                      />
                    </Actions>
                  </>
                )}
              </PaymentContainer>
            </InnerSection>
          )}
        </>
      )}
      {!isItInvoice && (
        <>
          {!newOrder && (
            <div>
              {!isEmpty(details?.order_tax) && (
                <InnerSection padding>
                  <PaymentContainer>
                    <Payments>
                      <DiscountTitle>
                        Tax ({details?.order_tax?.tax_title}) &nbsp;
                        {details?.order_tax?.tax_percent * 100}%
                      </DiscountTitle>
                      <Description></Description>
                    </Payments>

                    <Total>
                      <PixelCurrency value={details?.order_tax?.tax_amount} />
                    </Total>
                  </PaymentContainer>
                </InnerSection>
              )}

              <PaymentContainer>
                <Payments>
                  <Payments> Total</Payments>
                  <Description></Description>
                </Payments>

                <Total>
                  <PixelCurrency value={details?.total} />
                </Total>
              </PaymentContainer>
            </div>
          )}
        </>
      )}
    </PixelFlexBox>
  )
}
const DiscountTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.84);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 50%;
`
const InnerSection = styled.div<{ padding?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  border-bottom: 1px solid #e6e6e6;
  width: 100%;
  padding: ${(props) => (props.padding ? '0px' : '10px 0px')};
`

const PaymentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
  padding: 15px;
`

const Payments = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 60%;
  gap: 10px;
`
const Description = styled.div`
  display: flex;
  flex-direction: row;
  width: 40%;
`
const Total = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.84);
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 30%;
`
const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 9%;
`
const Amounts = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.84);
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 35%;
`
const HeaderEnd = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 15px;
  /* padding: 10px; */
  margin-right: 15px;
  cursor: pointer;
`
const NotAllowed = styled.div`
  cursor: not-allowed;
  font-size: 14px;
  color: ${$DCprimaryColor};
`
const ADDShippingLines = styled.div`
  width: 75%;
`
export default OrderShipping
